import { convertCamelToDashedCase } from "@cima/utils";
function getFieldWithValidityFromComponent(component) {
    return component.querySelector("input,select");
}
export function handleValueChange(event) {
    var _a;
    let field = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.target;
    if (!field) {
        field = getFieldWithValidityFromComponent(event.target);
    }
    updateErrorMessage(event.target, field);
}
export function updateErrorMessage(component, field) {
    const failedConstraintName = getFailedConstraintName(field);
    if (failedConstraintName) {
        const errorMessage = getErrorMessage(failedConstraintName, component, field);
        component.setAttribute("invalid-message", errorMessage);
    }
}
function getFailedConstraintName(field) {
    let constraintName;
    for (constraintName in field.validity) {
        if (field.validity[constraintName]) {
            return constraintName === "valid" ? undefined : constraintName;
        }
    }
}
function getErrorMessage(constraintName, component, field) {
    preserveOriginalInvalidMessage(component);
    let customMessageProp;
    if (constraintName === "customError") {
        customMessageProp =
            constraintName +
                field.validationMessage.charAt(0).toUpperCase() +
                field.validationMessage.substring(1);
    }
    const errorMessage = (customMessageProp && component.dataset[customMessageProp]) ||
        component.dataset[constraintName] ||
        component._originalInvalidMessage;
    if (typeof errorMessage !== "string") {
        console.warn(`No error message found for "${constraintName}" constraint for "${component.getAttribute("name")}" field.`);
    }
    return errorMessage || "";
}
function preserveOriginalInvalidMessage(component) {
    const originalInvalidMessage = component._originalInvalidMessage;
    if (originalInvalidMessage === undefined) {
        component._originalInvalidMessage =
            component.getAttribute("invalid-message");
    }
}
function createCustomValidationListener(validationName, validator) {
    return (event) => {
        const inputComponent = (event.target);
        const inputField = getInputFieldFromComponent(inputComponent);
        inputField.setCustomValidity(validator(inputField.value) ? "" : validationName);
        inputComponent.invalid = !inputField.validity.valid;
        updateErrorMessage(inputComponent, inputField);
    };
}
export function addCustomValidator(validationName, validator) {
    const eventListener = createCustomValidationListener(validationName, validator);
    const components = document.querySelectorAll(`prism-input-text[data-custom-error-${convertCamelToDashedCase(validationName)}]`);
    for (const component of components) {
        component.addEventListener("prismChange", eventListener);
    }
}
export function getInputFieldFromComponent(inputComponent) {
    return inputComponent.querySelector("input");
}
